import styled from "@emotion/styled";
import { ArrowRightOutlined } from "@ant-design/icons";
import { ReactNode } from "react";
import { numberFormatInt } from "utils/nuberFormat";
import { sd } from "../tokens";

interface TodoTileProps {
  count: number;
  label: string;
  hint?: string;
  icon: ReactNode;
  iconColor: string;
  onClick: () => void;
  loading?: boolean;
}

/** ไทล์ในแผงสีกรม — คลิกแล้วพาไปหน้าที่ต้องไปจัดการต่อ */
const TodoTile = ({ count, label, hint, icon, iconColor, onClick, loading }: TodoTileProps) => (
  <Tile type="button" onClick={onClick} dim={!loading && count === 0}>
    <IconBox color={iconColor}>{icon}</IconBox>
    <TextBox>
      <TopLine>
        <Count>{loading ? "—" : numberFormatInt(count)}</Count>
        <Label>{label}</Label>
      </TopLine>
      {hint ? <Hint>{hint}</Hint> : null}
    </TextBox>
    <ArrowRightOutlined style={{ color: sd.subtle, fontSize: 13 }} />
  </Tile>
);

export default TodoTile;

const Tile = styled.button<{ dim: boolean }>`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  border-radius: 10px;
  border: 1px solid ${sd.navyBorder};
  background: ${sd.navyTile};
  color: #fff;
  text-align: left;
  cursor: pointer;
  transition: transform 0.15s ease, border-color 0.15s ease;
  opacity: ${(p) => (p.dim ? 0.6 : 1)};

  &:hover {
    transform: translateY(-1px);
    border-color: ${sd.orange};
  }
`;

const IconBox = styled.div<{ color: string }>`
  width: 34px;
  height: 34px;
  flex: 0 0 auto;
  border-radius: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid ${(p) => p.color};
  color: ${(p) => p.color};
  font-size: 15px;
`;

const TextBox = styled.div`
  flex: 1;
  min-width: 0;
`;

const TopLine = styled.div`
  display: flex;
  align-items: baseline;
  gap: 8px;
  flex-wrap: wrap;
`;

const Count = styled.span`
  font-size: 19px;
  font-weight: 700;
`;

const Label = styled.span`
  font-size: 14px;
  font-weight: 500;
`;

const Hint = styled.div`
  margin-top: 2px;
  font-size: 12px;
  color: #9FB0CC;
`;
